import { render, staticRenderFns } from "./ChoferEmpresa.vue?vue&type=template&id=b354400e"
import script from "./ChoferEmpresa.vue?vue&type=script&lang=js"
export * from "./ChoferEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports